module.exports = __webpack_public_path__ + "static/media/shobhit.9d8956e9.jpeg";